export const API_URLS = {
  
  login: '/api/login',
  getCommonData: '/api/get_common_data',
  restorePassword: '/api/restore_password',
  authlog: '/api/authlog',
  
};
